<template>
	<div>
    <div class="modal-content-container">
      <b-row class="modal-row">
        <b-col cols="12">
          <b-form-input v-model="search"
                        type="text"
                        placeholder="Search" @input="changeSearch"></b-form-input>
          <transition name="fade">
            <e-button v-if="filteredCriteria.length === 0" color="blue-light" type="outlined" size="smaller" class="ml-2 new-criterion" @click="newCriterion"><b>+</b> Create new</e-button>
          </transition>
        </b-col>
      </b-row>
      <b-row class="modal-row">
        <b-col cols="9">
          <div class="modal-block-title">List of Criteria:</div>
        </b-col>
        <b-col cols="3">
          <div class="d-flex flex-row align-items-center justify-content-end">
            <b-btn class="e-create-rate__reset" variant="link" size="sm" @click="resetCriteria">Reset all</b-btn>
          </div>
        </b-col>
      </b-row>
      <b-row class="modal-row select-criteria-list" :class="{'is-loading': $wait.is('assets.searchCriteria')}" v-if="filteredCriteria.length === 0">
        <b-col key="empty-data" cols="12" class="align-items-center justify-content-center d-flex">
          <h3 v-if="search" class="criterion-item not-found">Not found similar to <b>"{{ this.search }}"</b> criteria</h3>
          <h3 v-else class="criterion-item not-found">No criteria yet</h3>
        </b-col>
      </b-row>

      <transition-group tag="b-row" class="select-criteria-list" :class="{'is-loading': $wait.is('assets.searchCriteria')}" name="fade" :duration="100" appear v-if="filteredCriteria.length !== 0">
        <b-col class="criterion-item" cols="4" v-for="criterion in filteredCriteria" :key="criterion.id">
            <e-button class="w-100 font-weight-bold" :color="isSelectedCriterion(criterion.id) ? 'blue-light' : 'custom-color'"  @click="toggleCriterion(criterion.id)" v-html="formattedCriterionTitle(criterion.id)"></e-button>
        </b-col>
      </transition-group>
    </div>
    <div class="modal-footer">
      <e-button type="outlined" @click="() => this.$emit('closeModal')">Cancel</e-button>
      <div class="d-flex ml-auto">
        <e-button :disabled="nextBtnDisabled" @click="onNextClick">Next</e-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex';

	export default {
		name: "em-rate-step-select-criteria",
    props: {
		  assetId: String,
      modalId: String,
    },
    data() {
		  return {
		    asset: null,
        search: null,
        searchFn: _.debounce(this.searchCriteria, 150),
      }
    },
    watch: {
      assetId: {
        async handler(current) {
          this.asset = this.getAsset(current);
          if(!this.asset) {
            return;
          }

          await this.fetchAssetCriteria([this.asset]);
          this.changeTitle();
        },
        immediate: true,
      }
    },
    methods: {
      ...mapActions('assets', {
        fetchAssetCriteria: 'fetchAssetsCriteria',
        searchCriteria: 'searchCriteria',
        pushCriterion: 'pushCriterion',
      }),
      ...mapActions('rate', {
        toggleCriterion: 'toggleCriterion',
        resetCriteria: 'resetCriteria'
      }),
      ...mapMutations('assets', {
        addCriterionToAsset: 'addCriterionToAsset',
      }),
      async changeSearch(search) {
        await this.searchFn(search);
      },
      newCriterion() {
        let newId = `new_${(new Date()).getTime()}`
        this.pushCriterion({id: newId, title: this.search});
        this.addCriterionToAsset({assetId: this.assetId, criterionId: newId});
        this.search = '';
      },
      onNextClick() {
        this.$emit('nextStep');
      },
      formattedCriterionTitle(id) {
        const criterion = this.getCriterion(id);
        const title = criterion && criterion.title ? criterion.title : '';

        if(!this.search) {
          return title;
        }

        let start = title.toLowerCase().indexOf(this.search.toLowerCase());
        let end = start + this.search.length;
        return title.slice(0, start) + '<b>' + title.slice(start, end) + '</b>' + title.slice(end, title.length);
      },
      changeTitle() {
        this.$emit('changeTitle', `Set a criteria for ${this.asset.name}`);
      }
    },
    computed: {
      ...mapGetters('rate', ['isSelectedCriterion']),
      ...mapGetters('rate', ['getCurrentCreateRateCriteria']),
      ...mapGetters('assets', {
        getAsset: 'asset',
        getCriterion: 'criterion',
        getCriteria: 'criteria',
      }),
      nextBtnDisabled() {
        return !(this.getCurrentCreateRateCriteria.length > 0);
      },
      filteredCriteria() {
        if(!this.asset) {
          return [];
        }

        if(!this.search) {
          let assetCriteria = _.sortBy(_.toArray(this.asset.criteria), 'popularity')
            .map(c => this.getCriterion(c.criterion))
            .filter(Boolean);
          let selectedCriteriaIds = this.getCurrentCreateRateCriteria;

          selectedCriteriaIds.forEach(c => {
            const criterion = this.getCriterion(c);

            if(criterion && !assetCriteria.find(ac => ac.id === c)) {
              assetCriteria.push(criterion);
            }
          });

          return assetCriteria;
        }

        return _.sortBy(_.toArray(_.mapValues(this.getCriteria)), 'popularity').filter(c => {
          if(!c || !c.title) {
            return false;
          }

          return c.title.toLowerCase().indexOf(this.search.toLowerCase()) !== -1;
        })
      },
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/rate/selectCriteria.vue